const e = {
  defaultProps: {
    PaperProps: {
      elevation: 5
    }
  }
};
export {
  e as default
};
